import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=201654f7&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=201654f7&prod&scoped=true&lang=css"
import style1 from "./PieChart.vue?vue&type=style&index=1&id=201654f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201654f7",
  null
  
)

export default component.exports